import { FC } from 'react';

import { Icon } from './Icon';
import { SvgIcon } from './SvgIcon.type';

export const IconHeadset: FC<SvgIcon> = (props) => (
  <Icon {...props} viewBox="0 0 24 24" name="headset">
    <path
      fillRule="evenodd"
      d="M12 5.5c-2.52 0-4.179 1.11-4.82 2.904-.146.413-.18.875-.18 1.388v3.875C7 14.403 6.403 15 5.667 15A2.167 2.167 0 0 1 3.5 12.833V12A2.5 2.5 0 0 1 6 9.5h.004c.013-.461.065-.954.235-1.431C7.053 5.786 9.159 4.5 12 4.5c2.84 0 4.947 1.286 5.761 3.569.17.477.222.97.235 1.431H18a2.5 2.5 0 0 1 2.5 2.5v.5A2.5 2.5 0 0 1 18 15h-.076l-.02.116A3.451 3.451 0 0 1 14.5 18v-1c1.198 0 2.22-.866 2.418-2.048l.082-.493V9.792c0-.513-.034-.975-.18-1.388C16.178 6.61 14.52 5.5 12 5.5Zm6 5V14a1.5 1.5 0 0 0 1.5-1.5V12a1.5 1.5 0 0 0-1.5-1.5Zm-12 0A1.5 1.5 0 0 0 4.5 12v.833c0 .645.522 1.167 1.167 1.167.184 0 .333-.15.333-.333V10.5Z"
    />
    <path fillRule="evenodd" d="M13.5 18a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm0 1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" />
  </Icon>
);
